import React, { useState } from 'react';
import {
  Typography, TextField, Button, Alert, Container, Paper
} from '@mui/material';
import axios from 'axios';
import '../css/Login.css'; // Pour fond et compatibilité visuelle
import API_BASE_URL from '../api';

const RequestResetPassword = () => {
  const [emailAddress, setEmailAddress] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API_BASE_URL}/api/users/reset-password`, { emailAddress });
      setSuccess('E-mail de réinitialisation envoyé avec succès.');
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Erreur lors de l’envoi de l’e-mail.');
      setSuccess('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <Container maxWidth="sm">
        <Paper elevation={6} sx={{ padding: 4, mt: 8, borderRadius: 3 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Réinitialiser le mot de passe
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              type="email"
              label="Adresse email"
              fullWidth
              required
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              margin="normal"
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isSubmitting}
              sx={{ mt: 2 }}
            >
              Envoyer le lien de réinitialisation
            </Button>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default RequestResetPassword;
